import { SHUTTLE_LOAD_CARRIERS_IDS } from '@/modules/vehicles/constants';
import { ValidFileExtension } from '@/modules/vehicles/types';

export class VehiclesUtil {
  // eslint-disable-next-line no-useless-constructor
  private constructor() {
    // Utility class
  }

  public static isShuttleVehicle = (vehicleId: string): boolean =>
    SHUTTLE_LOAD_CARRIERS_IDS.includes(vehicleId);

  public static buildVehicleAssetFileRef = (
    containerName: string,
    vehicleVariantId: string,
    extension: ValidFileExtension,
  ): string =>
    `${containerName}/${vehicleVariantId}-${VehiclesUtil.createTimestamp(new Date())}.${extension}`;

  private static createTimestamp = (date: Date): string =>
    [
      date.getUTCFullYear(),
      this.formatDatePart(date.getUTCMonth() + 1),
      this.formatDatePart(date.getUTCDate()),
      this.formatDatePart(date.getUTCHours()),
      this.formatDatePart(date.getUTCMinutes()),
      this.formatDatePart(date.getUTCSeconds()),
    ].join('');

  private static formatDatePart = (value: number): string => value.toString().padStart(2, '0');
}
